/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';

export enum ModularityActionTypes {
  InitModularityConfig = '[Modularity] init modularity config',
  SetModularityConfig = '[Modularity] set modularity config',
  SetModularityConfigFromRegistration = '[REGISTRATION] set modularity config'
}

export class InitModularityConfig implements Action {
  readonly type = ModularityActionTypes.InitModularityConfig;
}

export class SetModularityConfig implements Action {
  readonly type = ModularityActionTypes.SetModularityConfig;

  constructor(public payload: any) {}
}

export class SetModularityConfigFromRegistration implements Action {
  readonly type = ModularityActionTypes.SetModularityConfigFromRegistration;

  constructor(public payload: any) {}
}

export type ModularityActionList = InitModularityConfig | SetModularityConfig | SetModularityConfigFromRegistration;
